import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import classNameBind from 'classnames/bind';
import styles from './Transfer.module.css';
import TransferSegment from './components/TransferSegment';
import Arrows from './components/Arrows';
import CustomDragLayer from './components/CustomDragLayer';

const bindClasses = classNameBind.bind(styles);

const Transfer = ({ from, to, limit, onMoveItemToRight, onMoveItemToLeft, onLimitChange }) => (
  <div className={bindClasses('wrapper')} data-ppuc-id="Transfer">
    <DndProvider backend={HTML5Backend}>
      <CustomDragLayer />
      <TransferSegment {...from} limit={limit} onLimitChange={onLimitChange} isFrom onDragEnd={onMoveItemToRight} />
      <Arrows
        rightOnClick={onMoveItemToRight}
        leftOnClick={onMoveItemToLeft}
        rightDisabled={!from.selected.count}
        leftDisabled={!to.selected.count}
      />
      <TransferSegment {...to} limit={limit} onLimitChange={onLimitChange} onDragEnd={onMoveItemToLeft} />
    </DndProvider>
  </div>
);

Transfer.defaultProps = {
  limit: 10,
  onLimitChange: () => {},
};

export default Transfer;
